// extracted by mini-css-extract-plugin
module.exports = {"spacer":"W_dd","title-container":"W_df","titleContainer":"W_df","title":"W_bF"};